export function getCsrfToken(): string {
  return (
    document.querySelector('[name~=csrf-token]')?.getAttribute('content') || ''
  );
}

export const doRedirect = (location: string): void => {
  window.location.href = location || '/status';
};
